import { ISchema, PaywallComponentProps } from '../../@types'

// Variant B — highlight the discount amount.
export default (schema: ISchema): ISchema => ({
	...schema,
	overrides: {
		...schema.overrides,
		PaywallCountdownQuickAccess: ({ ctx }): PaywallComponentProps.CountdownQuickAccess => ({
			theme: 'discount',
			text: `<b>${ctx.discountPercent}%</b> discount reserved`,
			buttonEvent: 'scrollToPlanPicker',
		}),
	},
})
